import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

import { EntityNode } from '@/modules/pipelines/model/pipeline-alerts/entity-node';

export default function NoticeOwnershipBreadcrumb({
  chain,
  affected,
}: {
  chain: EntityNode[];
  affected: EntityNode[];
}) {
  if (chain.length < 2 && affected.length === 0) return null;

  return (
    <div className="d-flex flex-column gap-1" style={{ fontSize: 13 }}>
      {chain.length > 1 && (
        <div className="d-flex flex-wrap align-items-center gap-1">
          {chain.map((node, index) => (
            <span key={node._id} className="d-flex align-items-center gap-1">
              {index > 0 && (
                <FontAwesomeIcon icon={faChevronRight} size="xs" className="text-secondary" />
              )}
              <span title={`${node.type} · ${node._id}`}>{node.name}</span>
            </span>
          ))}
        </div>
      )}

      {affected.length > 0 && (
        <div className="d-flex flex-wrap align-items-center gap-2">
          <span className="text-secondary">Affected:</span>
          {affected.map((node, index) => (
            <span key={node._id} title={node._id}>
              {node.name} - {node.type}
              {index < affected.length - 1 && ','}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
